import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  alpha,
  Avatar,
  Fade,
} from "@mui/material";
import { EmojiEvents } from "@mui/icons-material";

const AchievementsCards = ({ title, date, img }) => {
  const theme = useTheme();

  return (
    <Fade in={true} timeout={600}>
      <Card
        sx={{
          flex: "1 1 280px",
          minWidth: "280px",
          maxWidth: "320px",
          borderRadius: "30px",
          border: "2px solid",
          borderColor: "#D4AF37",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          transition: "0.4s",
          overflow: "visible",
          position: "relative",
          pt: 4,
          textAlign: "center",
          "&:hover": {
            transform: "translateY(-15px)",
            boxShadow: "0 20px 50px rgba(212, 175, 55, 0.2)",
            borderColor: "#D4AF37",
          },
        }}
      >
        {/* Floating Icon */}
        <Box sx={{ 
          position: 'absolute', 
          top: -25, 
          left: '50%', 
          transform: 'translateX(-50%)',
          bgcolor: '#D4AF37',
          color: 'white',
          p: 1.5,
          borderRadius: '15px',
          boxShadow: '0 5px 15px rgba(212, 175, 55, 0.4)'
        }}>
          <EmojiEvents />
        </Box>

        <CardContent sx={{ p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Box sx={{ 
            width: 180, 
            height: 180, 
            mb: 3, 
            borderRadius: '50%', 
            overflow: 'hidden',
            border: '6px solid',
            borderColor: alpha('#D4AF37', 0.2),
            p: 1,
            bgcolor: 'white'
          }}>
            <Box
              component="img"
              src={img}
              alt={title}
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </Box>
          
          <Box sx={{ 
            px: 3, 
            py: 1, 
            borderRadius: '15px', 
            bgcolor: alpha(theme.palette.primary.main, 0.05),
            border: '1px solid',
            borderColor: alpha('#D4AF37', 0.3),
            mb: 2
          }}>
            <Typography variant="h6" fontWeight={800} color="text.primary">
              {title}
            </Typography>
          </Box>

          <Typography variant="subtitle2" fontWeight={700} color="success.main" sx={{ letterSpacing: '1px' }}>
            EARNED ON: {date}
          </Typography>
        </CardContent>
      </Card>
    </Fade>
  );
};

export default AchievementsCards;
